import React, { createContext, useContext, useEffect, useState } from "react";
import * as apiLib from "@/lib/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem(apiLib.TOKEN_KEY);
    if (!token) { setUser(false); setReady(true); return; }
    apiLib.fetchMe()
      .then((u) => setUser(u))
      .catch(() => { localStorage.removeItem(apiLib.TOKEN_KEY); setUser(false); })
      .finally(() => setReady(true));
  }, []);

  const signIn = async (email, password) => {
    const data = await apiLib.login(email, password);
    localStorage.setItem(apiLib.TOKEN_KEY, data.access_token);
    setUser(data.user);
    return data.user;
  };

  const signOut = () => {
    localStorage.removeItem(apiLib.TOKEN_KEY);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
